(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ripmoto-order-issue-skin"] && !Shopify.designMode) return;
  try {
    
  const styleId = 'ripmoto-order-issue-form-styles';
  const formStyles = `
    :host {
      --rm-black: #101010;
      --rm-red: var(--color-primary-button-background, #e11b22);
      --rm-red-hover: var(--color-primary-button-hover-background, #e62f36);
      --rm-cream: #f5f3ef;
      --rm-line: #d8d3ca;
      display: block;
      width: 100%;
    }

    #form-container-ref section[role='dialog'] {
      display: block !important;
      width: 100% !important;
      max-width: 960px !important;
      margin: 0 auto !important;
      padding: 0 !important;
      overflow: visible !important;
      border: 1px solid var(--rm-line) !important;
      border-top: 4px solid var(--rm-red) !important;
      border-radius: 2px !important;
      background: #ffffff !important;
      box-shadow: 9px 9px 0 var(--rm-black) !important;
      box-sizing: border-box !important;
    }

    #form-container-ref section[role='dialog'] > div:first-child {
      display: none !important;
    }

    #form-container-ref section[role='dialog'] > div:last-child {
      width: 100% !important;
      min-width: 0 !important;
      padding: 0 30px 30px !important;
      box-sizing: border-box !important;
    }

    #form-container-ref section[role='dialog'] section:has(> h2) {
      margin: 0 -30px 24px !important;
      padding: 24px 30px 20px !important;
      border-bottom: 3px solid var(--rm-red) !important;
      background: var(--rm-black) !important;
    }

    #form-container-ref section[role='dialog'] h2 {
      margin: 0 !important;
      color: #ffffff !important;
      font-family: var(--font-heading--family) !important;
      font-size: clamp(1.8rem, 4vw, 2.65rem) !important;
      font-weight: var(--font-heading--weight) !important;
      letter-spacing: 0.01em !important;
      line-height: 0.98 !important;
      text-align: left !important;
      text-transform: uppercase !important;
    }

    #form-container-ref section[role='dialog'] h2::after {
      content: '';
      display: block;
      width: 46px;
      height: 3px;
      margin-top: 12px;
      background: var(--rm-red);
    }

    #form-container-ref section[role='dialog'] section:has(> h2) p {
      max-width: 38rem;
      margin: 10px 0 0 !important;
      color: #ffffff !important;
      font-size: 0.9375rem !important;
      line-height: 1.5 !important;
      text-align: left !important;
    }

    #form-container-ref form {
      position: relative !important;
      display: grid !important;
      grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
      gap: 14px 16px !important;
      width: 100% !important;
      padding: 0 !important;
      box-sizing: border-box !important;
    }

    #form-container-ref form > * {
      min-width: 0 !important;
      margin: 0 !important;
    }

    #form-container-ref form > div:has(> shop-lead-capture) {
      position: absolute !important;
      width: 1px !important;
      height: 1px !important;
      overflow: hidden !important;
      clip-path: inset(50%) !important;
    }

    #form-container-ref form > fieldset[name='custom#preferred_resolution'],
    #form-container-ref form > button[type='submit'] {
      grid-column: 1 / -1 !important;
    }

    #form-container-ref form input:not([type='radio']):not([type='file']),
    #form-container-ref form textarea,
    #form-container-ref form button[type='button'] {
      width: 100% !important;
      min-height: 54px !important;
      padding: 14px 16px !important;
      border: 1.5px solid #bdb7ac !important;
      border-radius: 2px !important;
      background: #fbfaf7 !important;
      box-shadow: none !important;
      color: var(--rm-black) !important;
      font-size: 1rem !important;
      box-sizing: border-box !important;
      transition: border-color 150ms ease, outline-color 150ms ease, background-color 150ms ease !important;
    }

    #form-container-ref form textarea {
      min-height: 124px !important;
      resize: vertical !important;
    }

    #form-container-ref form > div:has(> textarea[name='custom#describe_the_issue'])::before {
      display: none !important;
    }

    #form-container-ref form input:not([type='radio']):not([type='file']):focus,
    #form-container-ref form textarea:focus,
    #form-container-ref form button[type='button']:focus-visible {
      border-color: var(--rm-black) !important;
      outline: 2px solid var(--rm-red) !important;
      outline-offset: 2px !important;
      background: #ffffff !important;
    }

    #form-container-ref form label,
    #form-container-ref form legend,
    #form-container-ref form p {
      color: var(--rm-black) !important;
    }

    #form-container-ref form > div:has([id='label-MM']) > div:last-child {
      display: grid !important;
      grid-template-columns: 0.8fr 0.8fr 1.4fr !important;
      gap: 8px !important;
    }

    #form-container-ref fieldset[name='custom#preferred_resolution'] {
      padding: 0 !important;
      border: 0 !important;
    }

    #form-container-ref fieldset[name='custom#preferred_resolution'] > div {
      display: grid !important;
      grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
      gap: 8px !important;
      margin-top: 8px !important;
    }

    #form-container-ref fieldset[name='custom#preferred_resolution'] label {
      display: flex !important;
      min-height: 46px !important;
      align-items: center !important;
      justify-content: center !important;
      gap: 8px !important;
      padding: 9px 10px !important;
      border: 1.5px solid #bdb7ac !important;
      border-radius: 2px !important;
      background: #fbfaf7 !important;
      color: var(--rm-black) !important;
      font-size: 0.875rem !important;
      line-height: 1.2 !important;
      text-align: center !important;
      box-sizing: border-box !important;
    }

    #form-container-ref fieldset[name='custom#preferred_resolution'] label:has(input:checked) {
      border-color: var(--rm-black) !important;
      background: var(--rm-black) !important;
      box-shadow: inset 4px 0 0 var(--rm-red) !important;
      color: #ffffff !important;
    }

    #form-container-ref fieldset[name='custom#preferred_resolution'] input[type='radio'] {
      flex: 0 0 auto !important;
      width: 16px !important;
      height: 16px !important;
      margin: 0 !important;
      accent-color: var(--rm-red) !important;
    }

    #form-container-ref fieldset[name='custom#preferred_resolution'] label:has(input:checked) span {
      color: #ffffff !important;
    }

    #form-container-ref form > div:has(input[type='file']) label {
      display: flex !important;
      min-height: 124px !important;
      align-items: center !important;
      justify-content: center !important;
      padding: 16px !important;
      border: 1.5px dashed #aaa398 !important;
      border-radius: 2px !important;
      background: var(--rm-cream) !important;
      box-sizing: border-box !important;
    }

    #form-container-ref form input[type='file'] + div span {
      padding: 10px 15px !important;
      border-radius: 2px !important;
      background: var(--rm-red) !important;
      color: #ffffff !important;
      font-family: var(--font-subheading--family) !important;
      font-size: 0.75rem !important;
      font-weight: 700 !important;
      letter-spacing: 0.06em !important;
      text-transform: uppercase !important;
    }

    #form-container-ref form > button[type='submit'] {
      width: 100% !important;
      min-height: 54px !important;
      margin-top: 4px !important;
      padding: 13px 20px !important;
      border: 2px solid var(--rm-red) !important;
      border-radius: 2px !important;
      background: var(--rm-red) !important;
      box-shadow: none !important;
      color: #ffffff !important;
      font-family: var(--font-subheading--family) !important;
      font-size: 0.875rem !important;
      font-weight: 700 !important;
      letter-spacing: 0.075em !important;
      text-transform: uppercase !important;
      box-sizing: border-box !important;
      transition: background-color 150ms ease, border-color 150ms ease !important;
    }

    #form-container-ref form > button[type='submit']:hover {
      border-color: var(--rm-red-hover) !important;
      background: var(--rm-red-hover) !important;
      box-shadow: none !important;
      transform: none !important;
    }

    #form-container-ref form > button[type='submit']:focus-visible {
      outline: 3px solid var(--rm-black) !important;
      outline-offset: 4px !important;
    }

    #form-container-ref form + div {
      margin-top: 22px !important;
      color: #6b6b6b !important;
      font-size: 0.75rem !important;
      line-height: 1.5 !important;
      text-align: center !important;
    }

    @media (prefers-reduced-motion: reduce) {
      #form-container-ref form input,
      #form-container-ref form textarea,
      #form-container-ref form button {
        transition: none !important;
      }
    }

    @media screen and (max-width: 699px) {
      #form-container-ref section[role='dialog'] {
        box-shadow: 4px 4px 0 var(--rm-black) !important;
      }

      #form-container-ref section[role='dialog'] > div:last-child {
        padding: 0 16px 22px !important;
      }

      #form-container-ref section[role='dialog'] section:has(> h2) {
        margin: 0 -16px 18px !important;
        padding: 20px 16px 17px !important;
      }

      #form-container-ref section[role='dialog'] h2 {
        font-size: clamp(1.75rem, 9vw, 2.25rem) !important;
      }

      #form-container-ref section[role='dialog'] section:has(> h2) p {
        margin-top: 8px !important;
        font-size: 0.875rem !important;
      }

      #form-container-ref form {
        grid-template-columns: minmax(0, 1fr) !important;
        gap: 10px !important;
      }

      #form-container-ref form > * {
        grid-column: 1 !important;
      }

      #form-container-ref form input:not([type='radio']):not([type='file']),
      #form-container-ref form textarea,
      #form-container-ref form button[type='button'] {
        min-height: 50px !important;
        padding: 12px 14px !important;
        font-size: 1rem !important;
      }

      #form-container-ref form textarea {
        min-height: 104px !important;
      }

      #form-container-ref fieldset[name='custom#preferred_resolution'] > div {
        gap: 6px !important;
        margin-top: 6px !important;
      }

      #form-container-ref fieldset[name='custom#preferred_resolution'] label {
        min-height: 44px !important;
        gap: 5px !important;
        padding: 8px 6px !important;
        font-size: 0.75rem !important;
      }

      #form-container-ref fieldset[name='custom#preferred_resolution'] input[type='radio'] {
        width: 14px !important;
        height: 14px !important;
      }

      #form-container-ref form > div:has(input[type='file']) label {
        min-height: 92px !important;
        padding: 12px !important;
      }

      #form-container-ref form > button[type='submit'] {
        min-height: 52px !important;
        margin-top: 3px !important;
      }

      #form-container-ref form + div {
        margin-top: 18px !important;
      }
    }
  `;

  const installFormStyles = () => {
    if (window.location.pathname.replace(/\/+$/, '') !== '/pages/order-issue') return false;
    const host = document.querySelector('shopify-forms-embed#app-embed');
    const root = host && host.shadowRoot;
    if (!root) return false;
    if (root.getElementById(styleId)) return true;
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = formStyles;
    root.appendChild(style);
    return true;
  };

  const beginFormStyling = () => {
    if (installFormStyles()) return;
    const observer = new MutationObserver(() => {
      if (installFormStyles()) observer.disconnect();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(() => observer.disconnect(), 15000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', beginFormStyling, { once: true });
  } else {
    beginFormStyling();
  }

  } catch(e) { console.error(e); }
})();
})();
